import React from "react";

const IndonesiaHealth = () => {
  return (
    <div
      id="indonesia"
      className="space-y-4 text-softBlack leading-loose text-base font-normal scroll-mt-24"
    >
      <p className="font-bold text-xl text-black mb-4">Indonesia</p>

      <ul className="space-y-1 list-disc list-outside ml-6">
        <li>
          According to research published in 2024, the prevalence of emotional
          mental disorders has increased from 6 percent in 2013 to 9.8 percent
          in 2018 (based on data from Indonesia Basic Health Research).
        </li>
        <li>
          According to WHO data, there are only{" "}
          <a
            href="https://www.who.int/data/gho/data/indicators/indicator-details/GHO/psychiatrists-working-in-mental-health-sector-(per-100-000)"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            0.310 psychiatrists
          </a>{" "}
          and{" "}
          <a
            href="https://www.who.int/data/gho/data/indicators/indicator-details/GHO/psychologists-working-in-mental-health-sector-(per-100-000)"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            0.175 psychologists
          </a>{" "}
          per 100,000 population.
        </li>
        <li>
          According to{" "}
          <a
            href="https://www.hrw.org/report/2016/03/20/living-hell/abuses-against-people-psychosocial-disabilities-indonesia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            Human Rights Watch
          </a>
          , misconceptions about mental health act as a major barrier to getting
          support. Mental health conditions are often associated with having
          sinned, lacking faith, or possession by evil spirits. Hence, the
          prevalence of seeking care from faith or traditional healers first is
          high, and medical advice and treatment is often only a last resort.
        </li>
        <li>
          One of the major challenges in Indonesia is the practice of{" "}
          <b>Pasung.</b> Pasung is the confinement or shackling of people with
          mental illnesses by their family or traditional and religious healers.
          Although Pasung was banned by the government in 1977, the practice
          continues to exist in many parts of Indonesia. A Human Rights Watch{" "}
          <a
            href="https://www.hrw.org/report/2016/03/20/living-hell/abuses-against-people-psychosocial-disabilities-indonesia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            report
          </a>{" "}
          estimates that 18,800 people currently live under Pasung. The
          government has taken several initiatives to promote mental health and
          end the practice of Pasung. However, lack of accessibility to mental
          health services and the shortage of community-based interventions act
          as barriers to change.
        </li>
      </ul>

      <p className="font-bold text-black">
        Mental health services through government channels
      </p>

      <div className="space-y-4">
        <ul className="space-y-1 list-disc list-outside ml-6">
          <li>
            According to{" "}
            <a
              href="https://www.researchgate.net/publication/367162976_Out_of_the_Shadows_A_Brief_Introduction_to_Mental_Health_in_Indonesia"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue underline"
            >
              a chapter
            </a>{" "}
            in the larger study In Sickness and in Health: Diagnosing Indonesia,
            which is a brief introduction to mental health in Indonesia, the
            initial access to mental health services in the country from
            government channels is through primary care facilities such as
            Puskesmas, pustu, polyclinics, and army and police clinics. Severe
            cases are referred to district or private hospitals which have
            capacity to address mental health concerns.
          </li>
          <li>
            Mental health awareness and screening activities also take place at
            Posyandus (integrated service posts). Posyandu services generally
            focus on maternal and child health, family planning, nutrition,
            immunization, and disease control. Mental health promotion
            activities, training for kaders (volunteers) to identify mental
            health conditions, and community outreach{" "}
            <a
              href="https://en.antaranews.com/news/289182/mental-health-awareness-through-posyandu-to-strengthen-service-post"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue underline"
            >
              have recently been included
            </a>{" "}
            as Posyandu services.
          </li>
        </ul>
      </div>

      <p className="font-bold text-black">Mental Health Act</p>

      <div className="space-y-4">
        <p>
          The Mental Health Act of Indonesia, enacted in 2014, puts
          national-level legislation on mental health in line with the
          International Convention on the Rights of Persons with Disabilities.
          While focusing on protecting the rights of persons with mental
          illness, the law also covers aspects like the treatment gap and puts
          the onus on the government to provide mental health services from the
          national to the local level. According to{" "}
          <a
            href="https://www.hrw.org/news/2014/09/16/break-shackles-stigma-mental-health-care-indonesia"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue underline"
          >
            an article
          </a>{" "}
          by Human Rights Watch, the Act emphasizes integrating mental health
          services into general health services and also calls for training more
          mental health professionals.
        </p>
      </div>
    </div>
  );
};

export default IndonesiaHealth;
